import React from 'react';

interface TabProps<T> {
  tabs: T[];
  activeTab: T;
  setActiveTab: (tab: T) => void;
  renderTabContent: (tab: T) => JSX.Element;
  tabLabels?: Partial<Record<string, string>>;
}

export default function PageWithTabsLayout<T extends string>({
  tabs,
  activeTab,
  setActiveTab,
  renderTabContent,
  tabLabels,
}: TabProps<T>): JSX.Element {
  return (
    <>
      <div className="mb-6 flex flex-wrap gap-1 border-b border-secondary-200">
        {tabs.map((tabKey) => (
          <button
            key={tabKey}
            type="button"
            onClick={() => setActiveTab(tabKey)}
            className={`relative px-4 pb-2 pt-2 text-sm font-medium transition-all duration-150 ${
              activeTab === tabKey
                ? 'text-primary-900 after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-primary'
                : 'text-gray-500 hover:text-primary-900'
            }`}>
            {tabLabels?.[tabKey] ?? tabKey.charAt(0).toUpperCase() + tabKey.slice(1)}
          </button>
        ))}
      </div>

      <div className="mb-8 flex flex-col gap-6">{renderTabContent(activeTab)}</div>
    </>
  );
}
